import { useState } from "react";
import request from "project-config/services/request/request";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import useForm from "antd/es/form/hooks/useForm";
import { useGlobalStore } from "@/store/GlobalStore";
import { useTabStore } from "../store/tab-store";
import { CouponStatus } from "../constant";

export interface ITransferAccountProps {
  destUserId: number;
  amount: string;
  couponNo: number;
}

export interface IFreeCouponTransferAccountProps {
  destUserId: number;
  id: number;
  couponNo: number;
}

export function useSubAccountInfo() {
  const { t } = useTranslation("coupon");
  const {
    subAccountInfo,
    defaultSubAccount,
    dealCouponsData,
    isMainUser,
    defaultAccount,
    setCurrentStatus,
  } = useTabStore();
  const [isTransferModalOpen, setTransferModalOpen] = useState(false);
  const [isFreeCouponTransferModalOpen, setFreeCouponTransferModalOpen] =
    useState(false);
  const [transferForm] = useForm<ITransferAccountProps>();
  const [freeCouponTransferForm] = useForm<IFreeCouponTransferAccountProps>();
  const { isSubAccount, userInfo } = useGlobalStore();
  const [isLoading, setIsLoading] = useState(false);

  const handleTransferAmount = async (transferCoupon: number) => {
    if (isLoading) return;
    transferForm
      .validateFields()
      .then(async () => {
        const destUserIdValue = isSubAccount
          ? userInfo?.mainUserId
          : !isMainUser
          ? userInfo?.userId
          : transferForm.getFieldValue("destUserId") || defaultSubAccount;
        setIsLoading(true);
        let params = {
          destUserId: destUserIdValue,
          amount: +transferForm.getFieldValue("amount"),
          couponNo: transferCoupon,
        } as any;
        if (!isSubAccount && !isMainUser) {
          params.originUserId = defaultAccount;
        }
        const { result, message: text } = await request.post(
          "/api/rendering/pay/recharge/giveUserCoupon",
          params
        );
        setIsLoading(true);
        if (result) {
          message.success(t("coupon_pages_transfer_success"));
          setTransferModalOpen(false);
          setCurrentStatus(CouponStatus.All);
          isMainUser ? dealCouponsData() : dealCouponsData(defaultAccount);
        } else {
          let messageTip = text || "";
          if (!subAccountInfo.length && !isSubAccount)
            messageTip = "plaese_add_sub_account";
          message.error(t(messageTip));
        }
      })
      .catch(() => {});
  };

  const handleTransferCoupon = async (
    transferCoupon: number,
    couponId: number
  ) => {
    if (isLoading) return;
    const handle = async () => {
      setIsLoading(true);
      const { result, message: text } = await request.post(
        "/api/rendering/pay/recharge/giveUserVoucher",
        {
          destUserId: destUserIdValue,
          couponNo: transferCoupon,
          id: couponId,
        }
      );
      setIsLoading(true);
      if (result) {
        message.success(t("coupon_pages_transfer_success"));
        setTransferModalOpen(false);
        isMainUser ? dealCouponsData() : dealCouponsData(defaultAccount);
      } else {
        let messageTip = text || "";
        if (!subAccountInfo.length && !isSubAccount)
          messageTip = "plaese_add_sub_account";
        message.error(t(messageTip));
      }
    };

    const destUserIdValue = isSubAccount
      ? userInfo?.mainUserId
      : freeCouponTransferForm.getFieldValue("destUserId") || defaultSubAccount;
    if (isSubAccount) {
      handle();
    } else {
      freeCouponTransferForm
        .validateFields()
        .then(async () => {
          handle();
        })
        .catch(() => {});
    }
  };

  return {
    handleTransferAmount,
    isTransferModalOpen,
    setTransferModalOpen,
    transferForm,
    isLoading,
    isFreeCouponTransferModalOpen,
    setFreeCouponTransferModalOpen,
    freeCouponTransferForm,
    handleTransferCoupon,
  };
}
